import React from "react";
import { Box, Typography, Paper, Grid, Chip, Divider } from "@mui/material";
import { Numbers, Title, Description } from "@mui/icons-material";
import { ProcessSection } from "../../../api/process-sections";

interface ProcessSectionDetailsProps {
  section: ProcessSection;
}

export function ProcessSectionDetails({ section }: ProcessSectionDetailsProps) {
  return (
    <Box sx={{ mt: 2 }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>
          {section.name}
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Box display="flex" alignItems="center" mb={2}>
              <Numbers sx={{ mr: 1, color: "primary.main" }} />
              <Typography variant="subtitle1" fontWeight="bold">
                شناسه بخش:
              </Typography>
            </Box>
            <Typography variant="body1" sx={{ mr: 4 }}>
              {section.id}
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box display="flex" alignItems="center" mb={2}>
              <Title sx={{ mr: 1, color: "primary.main" }} />
              <Typography variant="subtitle1" fontWeight="bold">
                شماره بخش:
              </Typography>
            </Box>
            <Chip
              label={section.sectionNumber}
              color="primary"
              variant="outlined"
            />
          </Grid>

          {section.description && (
            <Grid item xs={12}>
              <Box display="flex" alignItems="center" mb={2}>
                <Description sx={{ mr: 1, color: "primary.main" }} />
                <Typography variant="subtitle1" fontWeight="bold">
                  توضیحات:
                </Typography>
              </Box>
              <Typography variant="body1" sx={{ mr: 4 }}>
                {section.description}
              </Typography>
            </Grid>
          )}
        </Grid>

        <Divider sx={{ my: 3 }} />

        <Box>
          <Typography variant="h6" gutterBottom>
            اطلاعات تکمیلی
          </Typography>
          <Typography variant="body2" color="text.secondary">
            این بخش فرایند با شماره {section.sectionNumber} و نام "
            {section.name}" تعریف شده است.
            {section.description && ` توضیحات: ${section.description}`}
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
}
